<template>
    <div class="createStarMgt spackage padding-20 bgc box-shadow" v-loading="loading">

        <el-alert title="请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容。" type="warning"  :closable="false" show-icon></el-alert>

        <section style="width: 811px;">
            <h1>基本信息</h1>
            <el-form :model="starMgtForm" :rules="rules" ref="starMgtForm" label-width="100px" class="starmgt-form">
                <el-form-item label="星球名称" prop="starname">
                    <el-input v-model="starMgtForm.starname" placeholder="请输入星球名称（12字以内）" maxlength="12" show-word-limit></el-input>
                </el-form-item>

                <el-form-item label="星球类型" prop="feetype">
                    <el-select v-model="starMgtForm.feetype" placeholder="请选择星球类型">
                        <el-option v-for="item in feetype" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <span style="margin-left: 15px">创建后不可修改</span>
                    <el-form-item label="星球价格" prop="joinfactmoney" v-if="starMgtForm.feetype === 3" style="margin-top: 10px">
                        <el-input v-model="starMgtForm.joinfactmoney" style="width: 200px;"></el-input> <span style="margin-left: 15px">元</span>
                    </el-form-item>
                    <el-form-item label="有效期" v-if="starMgtForm.feetype === 3" prop="memberexpiretime">
                        <el-select v-model="starMgtForm.memberexpiretime" palceholder="请选择有限期">
                            <el-option v-for="item in memberexpiretime" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="星球标签" prop="tagcode">
                    <el-select v-model="starMgtForm.tagcode" placeholder="请选择星球标签">
                        <el-option v-for="item in tagNameList" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="星球头像" prop="logodata.furl" class="upload-image" required>
                    <div class="upload">
                        <upload class="avatar-uploader" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                    </div>
                   <div class="position">
                       <el-button type="warning" @click="dialogVisible = true">系统头像</el-button>
                       <p>建议上传尺寸750*445，jpg或png格式，不超过2M</p>
                   </div>
                </el-form-item>


                <el-form-item label="公开星球">
                    <el-switch v-model="starMgtForm.ispublic"></el-switch>
                    <div class="switch-text">
                        <p>公开后可以获得流量曝光,可以在星球内的“设置”中关闭公开</p>
                    </div>
                </el-form-item>

                <el-form-item label="星球介绍">
                    <el-input type="textarea" v-model="starMgtForm.stardesp" placeholder="请简要描述该星球（80字以内）" maxlength="80" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('starMgtForm')">保存</el-button>
                    <!--<el-button style="margin-left: 80px;" @click="cancel">取消</el-button>-->
                </el-form-item>
            </el-form>
        </section>

        <el-dialog title="系统头像" :visible.sync="dialogVisible" width="516px">

            <div class="headerimg">

                <template v-for="(img,index) in headerImg">
                    <input :index="index" :id="'img_'+ index" name="headerimg" type="radio" style="display:none">
                    <label :for="'img_'+ index">
                        <img :src="imgUrl + img" alt="headerimg">
                    </label>
                </template>
                <div class="btn">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="headerimg()">确定</el-button>
                </div>

            </div>

        </el-dialog>


    </div>
</template>

<script>
import Upload from 'base/upload/upload'
import UploadFile from 'base/upload/uploadFile'
import {getStarInfo, saveStarInfo} from '@/api/starMgtApi' // 引入星球管理 api 资源文件
import {mapActions} from 'vuex' // 引入 vuex 组件
import {getCookie,formatFileInfo} from '@/common/js/tools' // 引入 tools 库

import $ from 'jquery' // 引入 jquery 组件

export default {
    name: "CreateStarMgt",
    data() {
        let validatelogodata = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择星球头像'))
            } else {
                callback()
                if(value.furl) {
                    this.starMgtForm.logodata = value.furl
                }
            }
        }
        return {
            loading: false,
            token: getCookie('token'), // token
            dialogVisible: false,
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            innerid: this.$route.query.innerid, // 星球编号
            type: this.$route.query.type,
            imgUrl: "http://img.capwhale.com/mp/bg/", // 服务器头像图片url
            headerImg: [
               'starHeadImgs/1.png',
               'starHeadImgs/2.png',
               'starHeadImgs/3.png',
               'starHeadImgs/4.png',
               'starHeadImgs/5.png',
               'starHeadImgs/6.png',
               'starHeadImgs/7.png',
               'starHeadImgs/8.png',
               'starHeadImgs/9.png',
               'starHeadImgs/10.png',
               'starHeadImgs/11.png',
               'starHeadImgs/12.png',
               'starHeadImgs/13.png',
               'starHeadImgs/14.png',
               'starHeadImgs/15.png',
               'starHeadImgs/16.png',
               'starHeadImgs/17.png',
               'starHeadImgs/18.png',
               'starHeadImgs/19.png',
               'starHeadImgs/20.png',
               'starHeadImgs/21.png',
               'starHeadImgs/22.png'
            ],  // 服务器系统头像地址
            feetype: [{label: '完全免费',value: 1},{label: '分享解锁',value: 2},{label: '完全收费',value: 3}],
            memberexpiretime: [{label: '成员加入日期往后计算一年', value: 1},{label: '成员加入后一直有效', value: 0}],
            imageUrl: '',   // 本地图片地址
            starMgtForm:{
                feetype: '',
                joinfactmoney: '',
                memberexpiretime: '',
                starname: '',
                tagcode: '',
                logodata: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimetype: '',
                    objecttype: '',
                    furl: ''
                },
                ispublic: false,
                stardesp: ''
            },  // 接口参数
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: '',
                height: ''
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            tagNameList: [
                {
                    name: '金融',
                    value: '01',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '科技',
                    value: '02',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '创业',
                    value: '03',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '资本',
                    value: '04',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '游戏',
                    value: '06',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '互联网',
                    value: '05',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '消费',
                    value: '07',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '教育',
                    value: '08',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '地产',
                    value: '09',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '医疗',
                    value: '10',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '健康',
                    value: '11',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '文娱',
                    value: '12',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '环保',
                    value: '13',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '智能制造',
                    value: '15',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: 'IT',
                    value: '14',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '服务业',
                    value: '16',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '新零售',
                    value: '17',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '新媒体',
                    value: '18',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '新材料',
                    value: '19',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '连锁',
                    value: '20',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: 'SaaS',
                    value: '21',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '区块链',
                    value: '22',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '人工智能',
                    value: '23',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '营销',
                    value: '24',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '商业管理',
                    value: '25',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '制造业',
                    value: '26',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                },
                {
                    name: '其他',
                    value: '27',
                    checked: false,
                    color: 'rgb(242, 242, 242)'
                }

            ],  // 星球标签
            rules: {
                starname: [
                    { required: true, message: '请输入星球名称', trigger: 'blur' }
                ],
                tagcode: [
                    { required: true, message: '请选择星球标签', trigger: 'change' }
                ],
                logodata: [
                    {validator: validatelogodata,message: '请上传星球头像', required: true, trigger: 'change'}
                ],
                feetype: [
                    { required: true, message: '请选择星球类型', trigger: 'change' }
                ],
                joinfactmoney: [
                    { required: true, message: '请输入收费价格', trigger: 'change' }
                ],
                memberexpiretime: [
                    { required: true, message: '请选择有限期', trigger: 'change' }
                ],
            },
            updateImgStatus: false  // 更改图片操作状态 true 更改 false 未更改
        }
    },
    methods: {
        updateimg() {
            let reads = new FileReader(),
                file = document.getElementById('file').files[0],
                isJPG,
                $this = this
            const isLt2M = file.size / 1024 / 1024 < 2;
            if(file.type === 'image/jpeg' || file.type === 'image/png') {
                isJPG = true
            } else {
                isJPG = false
            }

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 jpg/png 格式!')
                return false
            }

            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!')
                return false
            }

            reads.readAsDataURL(file);

            reads.onload = function(){

                $this.starMgtForm.logodata = $this.imageUrl = this.result
                // 重置头像
                $("input[name=headerimg]:checked").prop('checked',false)
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    let updata = JSON.parse(JSON.stringify(this.starMgtForm))

                    updata.ispublic = updata.ispublic === true ? 1 : 0

                    // updata.LoginToken =  this.token
                    updata.innerid = this.innerid

                    for (let item in this.tagNameList) {
                        if (this.tagNameList[item].value === updata.tagcode) {
                            updata.tagname = this.tagNameList[item].name
                        }
                    }



                    // 当头像图片发生变更时
                    if( this.updateImgStatus ) {
                        updata.logodata.type = 'add'
                        // updata.logodata = JSON.stringify(updata.logodata)
                    //     console.log(updata.logodata)
                    //     console.log(this.updateImgStatus)
                        updata.logodata = formatFileInfo(updata.logodata)
                    //     console.log(formatFileInfo(updata.logodata))
                    } else {
                        updata.logodata = ''
                    }

                    this.setLoading(true)

                    saveStarInfo({
                        data: updata,
                        success: data => {
                            this.$message.success('保存成功')
                            this.setLoading(false)
                            this.$router.back()
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })

                    // alert('submit!');
                } else {
                    console.log('error submit!!')
                    return false;
                }
            });
        },
        headerimg() {

            // 取得选择图片的下标
            let index = $("input[name=headerimg]:checked").attr('index')

            if (index) {

                let imgurl = this.headerImg[index];

                this.starMgtForm.logodata.bucket = this.starMgtForm.logodata.fname = this.starMgtForm.logodata.fsize
                = this.starMgtForm.logodata.width = this.starMgtForm.logodata.height = this.starMgtForm.logodata.key
                = this.starMgtForm.logodata.mimetype = this.starMgtForm.logodata.objecttype = this.starMgtForm.logodata.keyid
                = this.starMgtForm.logodata.vsource = ''

                this.starMgtForm.logodata.furl = this.imgUrl + imgurl
                this.$refs.coverfile.setImage( this.starMgtForm.logodata.furl)
                this.dialogVisible = false

                // 发生头像图片变更操作
                this.updateImgStatus = true

            } else {
                this.$message.error('请选择头像')
            }
        },
        // 设置图片信息（本地）
        setCoverfile(img) {
            // 发生头像图片变更操作
            this.updateImgStatus = true

            $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
            this.starMgtForm.logodata = img
        },
        ...mapActions([
            'setLoading'
        ])
    },
    mounted() {
        // if (this.type !== 'add') {
        //     let data = {
        //         // LoginToken: this.token,
        //         innerid: this.innerid
        //     }
        //     this.setLoading(true)
        //
        //     getStarInfo({
        //         data: data,
        //         success: data => {
        //             this.setLoading(false)
        //
        //             let mdata = data.data
        //             this.starMgtForm.starname = mdata.starname
        //             this.starMgtForm.ispublic = mdata.status === 0?false:true
        //             this.starMgtForm.stardesp = mdata.stardesp
        //
        //             if(mdata.tagcode) {
        //                 this.starMgtForm.tagcode = mdata.tagcode
        //             }
        //             if (mdata.starlogourl) {
        //                 this.starMgtForm.logodata.furl = mdata.starlogourl
        //                 this.$refs.coverfile.setImage(this.starMgtForm.logodata.furl)
        //             }
        //
        //         },
        //         error: data => {
        //             this.setLoading(false)
        //             console.log(data)
        //         }
        //     })
        // }
    },
    components: {
        Upload,
        UploadFile
    }
}
</script>

<style lang="scss" type="text/scss"  rel="stylesheet/scss">
    .createStarMgt {
        .headerimg {
            margin-right: -10px;

            label {
                position: relative;
                display: inline-block;
                cursor: pointer;
                margin-right: 10px;
                margin-bottom: 10px;
                width:110px;
                height:65px;
                box-sizing: border-box;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
            input[type=radio]:checked + label {
                border: solid 1px #409EFF;
            }

            input[type=radio]:checked + label:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                width: 23px;
                height: 23px;
                background: url("../../../common/images/starMgtHeaderimg/radio.png") no-repeat center ;
                background-size: 23px;
            }
            .btn {
                margin-top: 20px;
                text-align: center;
            }
        }

        h1 {
            margin: 20px 0;
            padding-left: 8px;
            color: #303133;
            font-weight: 500;
            font-size: 16px;
            border-left: solid 2px #409EFF;
        }
        .el-input__prefix, .el-input__suffix {
            height: auto;
        }
        .el-form-item__label {
            text-align: left;
        }
        .upload {
            float: left;
            margin-right: 45px;
        }
        .idcardImage .avatar-uploader{
            box-sizing: border-box;
            width: 170px;
            height: 170px;
        }

        .avatar {
            width: 212px;
            height: 126px;
            display: block;
        }

        .el-textarea textarea {
            height: 105px;
        }

        .position {
            margin-top: 45px;
            p {
                color: #C0C4CC;
                font-size: 14px;
            }
        }

        .switch-text,
        .el-switch {
            float: left;
        }
        .el-switch {
            margin-top: 10px;
        }
        .switch-text p {
            margin-left: 20px;
            color: #909399;
            font-size: 14px;
        }
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .icon_upload:before {
            background-size: 30%;
            background-position: center;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 212px;
            height: 126px;
            line-height: 178px;
            text-align: center;
        }
    }
</style>
